/*
 * @Author: Fan
 * @Date: 2020-04-16 19:51:40
 * @description:
 * @LastEditors: Fan
 */
import { DataType } from "../../../typings";
import { inputControlOptions } from ".";
import i18n from "../../../i18n";
export const selectControlOptions = {
    $id: "selectControlOptions",
    type: DataType.Object,
    $ref: inputControlOptions.$id,
    properties: {
        defaultValue: {
            type: DataType.String,
            title: i18n.t('dataitem.DefaultValue').toString(),
        },
        options: {
            type: DataType.String,
            title: i18n.t('dataitem.Options').toString(),
            default: i18n.t('dataitem.RadioDefaultOptions').toString(),
        },
    },
};
